import { apiUrl } from './config'
import { get } from './http'

const isTokenValid = async (): Promise<boolean> => {
  try {
    await get(`${apiUrl}/auth/tokencheck`)
    return true
  } catch (err) {
    return false
  }
}

const clearLoginCache = (): void => {
  localStorage.removeItem("user_id")
  localStorage.removeItem("adminId")
  localStorage.removeItem("role")
  localStorage.removeItem("fullName")
  localStorage.removeItem("entity_id")
  localStorage.removeItem("guest-token")
  if (localStorage.getItem('rememberMe') !== 'true') localStorage.removeItem('user_email')
  sessionStorage.clear()
}

export {
  isTokenValid,
  clearLoginCache
}